import Vue from 'vue'
import App from './App.vue'
import { rtdbPlugin } from 'vuefire'
import BootstrapVue from 'bootstrap-vue'

import router from './router'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// import * as firebase from "firebase";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCheck);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(rtdbPlugin);
Vue.use(BootstrapVue);

// const configOptions = {
//     apiKey: "AIzaSyAeIocDhvjAxfC397tOPp5eW3G1M2qCkOg",
//     authDomain: "eventpop-registration-develop.firebaseapp.com",
//     databaseURL: "https://eventpop-bootcamp-2909-develop.firebaseio.com",
//     projectId: "eventpop-registration-develop",
//     storageBucket: "eventpop-registration-develop.appspot.com",
//     messagingSenderId: "335920685449",
//     appId: "1:335920685449:web:548a6f86618bded9b18158",
//     measurementId: "G-LY3EEN97RR"
// };

// firebase.initializeApp(configOptions);

new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
});
